<div class="card">
    <div
        class="card-header d-flex justify-content-between align-items-center"
        (click)="toggleAccordion($event)"
        [ngClass]="{ 'card-invalid': accordionInvalid }"
    >
        <div class="d-flex align-items-center">
            <fa-icon *ngIf="open" [icon]="faChevronDown" size="lg"></fa-icon>
            <fa-icon *ngIf="!open" [icon]="faChevronRight" size="lg"></fa-icon>
            <ng-container *ngIf="displayStatusIcon">
                <fa-icon *ngIf="accordionInvalid" [icon]="faTimesCircle" size="lg" class="status-icon"></fa-icon>
                <fa-icon
                    *ngIf="(!isUnknownStatusAllowed || accordionOpened) && !accordionInvalid"
                    [icon]="faCheckCircle"
                    size="lg"
                    class="status-icon valid"
                ></fa-icon>
                <fa-icon
                    *ngIf="isUnknownStatusAllowed && !accordionOpened && !accordionInvalid"
                    [icon]="faQuestionCircle"
                    size="lg"
                    class="status-icon"
                ></fa-icon>
            </ng-container>
            <h4 class="ps-2 pt-1">
                <ng-content select="[sectionHeader]"></ng-content>
            </h4>
        </div>
        <fa-icon
            *ngIf="showDataAvailabilityStatus && hasData"
            [icon]="faCircle"
            size="xs"
            class="status-icon"
        ></fa-icon>
    </div>
    <div class="card-body" *ngIf="open">
        <ng-content select="[sectionBody]"></ng-content>
        <ng-container *ngIf="allowCollapse">
            <div class="close-container">
                <button class="btn btn-link" (click)="toggleAccordion($event)">
                    <ng-content select="[closeButton]"></ng-content>
                </button></div
        ></ng-container>
    </div>
</div>
